import React, { PureComponent } from 'react';
import { Dialog, CheckboxGroup, Icon } from '@tencent/spaui';
import './index.scoped.less';
import globalStore from '@/stores/index';
import CheckAgency from './CheckAgency';
import queryDataStore from './queryDataStore';
import { queryConditionName } from './config';
import _ from 'lodash';
import { downloadConfig } from '../config';
import PropTypes from 'prop-types';

export default class CrossAgencyDownload extends PureComponent {
  static propTypes = {
    downloadType: PropTypes.oneOf(['default', 'multi', 'newSeenOld']),
  }

  state = {}

  handleCancel() {
    this.setState({
      value: [],
    });
    this.props.handleCancel();
  }

  handleChange = (n, v) => {
    this.props.onChange(n, v);
  }

  // 处理查询条件
  handleQueryCondition = () => {
    const { queryDataValue } = this.props;
    const selectedTags = JSON.parse(window.localStorage.getItem('customFilterData') || '{}')[this.props.customTagsName] || [];
    const queryData = queryDataStore.queryData;
    const arr = [];
    _.keys(queryDataValue).forEach((x) => {
      if (queryConditionName.hasOwnProperty(x) && queryDataValue[x]) {
        const obj = {
          label: queryConditionName[x],
        };
        switch (x) {
          case 'begin_date':
            obj.value = `${queryDataValue[x]}~${queryDataValue.end_date}`;
            break;
          case 'customized_label_list':
            if (queryDataValue[x].length !== 0) {
              queryDataValue[x].forEach((y) => {
                const item = {
                  value: y.label_values,
                  label: (selectedTags.find((j) => y.label_type == j.label_type) || {}).label_type_name,
                };
                arr.push(item);
              });
            }
            return;
          default:
            obj.value = queryData.get(x)?.find((y) => y.value == queryDataValue[x])?.label || queryDataValue[x];
            break;
        }
        arr.push(obj);
      }
    });
    return arr;
  }

  render() {
    const { value } = this.state;
    const { show = false, handleSubmit, agency_list, showQueryCond } = this.props;

    const queryData = this.handleQueryCondition();
    return (
      <Dialog useNewUI size="extraLarge" className="crossAgencyDownloadDialog" backdrop={true} title="跨服务商下载数据" show={show} onSubmit={(e) => handleSubmit(e, value)} onClose={() => this.props.handleDialogShow(false)} onCancel={() => this.props.handleDialogShow(false)}>
        <div className="CrossAgencyDownload">
          {showQueryCond && queryData.length ? (
            <div className="queryCondition">
              <h4 className="queryTitle">当前筛选条件</h4>
              <p className="queryCon">
                {queryData.map((x) => {
                  return <span key={x.value}>{x.value ? `${x.label}:${x.value}` : null}</span>;
                })}
              </p>
            </div>
          ) : null}
          <div className="checkAgency">
            <h4 className="modal-title">
              {' '}
              选择帐户
              <span className="checkAgencyTip">
                <Icon className={'tipIcon'} name="info-filled" />
                不同服务商ID的数据将在同一个excel文件内同一个sheet展示
              </span>
            </h4>
            {agency_list.map((x) => {
              return <CheckAgency key={x.agency_uid} data={x} handleChange={this.handleChange} />;
            })}
          </div>
        </div>
      </Dialog>
    );
  }
}
